import React from 'react';
import { Box, Grid, makeStyles } from '@material-ui/core';
import { Info } from 'react-feather';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import {
  formStyle,
  StyledGridLeft,
  StyledCaption,
  StyledShortBody,
} from 'components/AccordionReleveSituation/styles';
import messages from 'components/AccordionWithoutExpand/messages';
import { translate } from 'helpers/intl';
import { StyledPaper } from 'components/AccordionWithoutExpand/styles';
import { renderUnit, currencyFormat } from 'utils/string';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const useStyles = makeStyles({
  ...formStyle,
});

interface AccordionReleveSituationType {
  intl: IntlShape;
  rachatsEncours: number;
  avanceEncours: number;
}

const AccordionWithoutExpand = ({
  rachatsEncours,
  avanceEncours,
  ...props
}: AccordionReleveSituationType) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const classes = useStyles();
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StyledPaper>
            <Box width="100%">
              <Grid container spacing={3}>
                <Grid item>
                  <Grid item>
                    <Grid container spacing={1}>
                      <Grid item>
                        <StyledCaption>
                          {translate(get(messages, 'rachatsEncours'), props)}
                        </StyledCaption>
                      </Grid>
                      <StyledGridLeft item xs={1}>
                        <Tooltip
                          title={translate(
                            get(messages, 'rachatsEncoursDescription'),
                            props,
                          )}
                        >
                          <Info
                            className={classes.infoIcon}
                            fontSize={'small'}
                          />
                        </Tooltip>
                      </StyledGridLeft>
                    </Grid>
                  </Grid>

                  <Grid item dir="ltr">
                    <Box marginBottom={0}>
                      <StyledShortBody reverse={reverse}>
                        {currencyFormat(rachatsEncours) +
                          '' +
                          renderUnit(rachatsEncours, reverse)}
                      </StyledShortBody>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </StyledPaper>
        </Grid>
        <Grid item xs={12}>
          <StyledPaper>
            <Box width="100%">
              <Grid container spacing={3}>
                <Grid item>
                  <Grid item>
                    <Grid container spacing={1}>
                      <Grid item>
                        <StyledCaption>
                          {translate(get(messages, 'avanceEncours'), props)}
                        </StyledCaption>
                      </Grid>
                      <StyledGridLeft item xs={1}>
                        <Tooltip
                          title={translate(
                            get(messages, 'avanceEncoursDescription'),
                            props,
                          )}
                        >
                          <Info
                            className={classes.infoIcon}
                            fontSize={'small'}
                          />
                        </Tooltip>
                      </StyledGridLeft>
                    </Grid>
                  </Grid>

                  <Grid item dir="ltr">
                    <Box marginBottom={0}>
                      <StyledShortBody reverse={reverse}>
                        {currencyFormat(avanceEncours) +
                          '' +
                          renderUnit(avanceEncours, reverse)}
                      </StyledShortBody>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </StyledPaper>
        </Grid>
      </Grid>
    </>
  );
};

export default injectIntl(AccordionWithoutExpand);
